<div class="wrapper" [ngClass]="{'active':active}" >
  <i [innerHtml]=" document!.name | fileTypeIcon : true" class="{{ document!.name | fileTypeIcon }}" (click)="toggle()"></i>
  <div class="details" (click)="toggle()">
    <p><b>TYPE:</b> {{document?.typeName}}</p>
    <p><b>NAME:</b> {{document?.name}}</p>
  </div>
    <input type="checkbox" [id]="'checkbox-'+id" #checkbox [checked]="selected">
    <i class="icon" [ngClass]="{'icon-checkmark': checkbox.checked}" (click)="select()"></i>
</div>
